import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import _ from 'lodash';

import { PubSubKeys, TicketStatuses, NAMRA_ORGANIZATION_ID, NAMRA_DIRECT_CALL_ALLOWED_USER_IDS } from '../../../../store/constants';
import { callTicket } from '../../../../store/actions/ticketsActions';

function AssistTicket({ ticket }) {
    const dispatch = useDispatch();
    const {hostname, supportDeskId, authenticatedUser, organizationId } = useSelector(state => state.auth);
    const { activeManagementTicketId, activeTicketId } = useSelector(state => state.tickets);
    const supportDesks = useSelector(state => state.services.supportDesks);

    const manageTicket = (volume, callType) => {
        const action = 'callTicket';
        const supportDesk = supportDesks.find(data => data.id === supportDeskId);
    
        // deep clone with lodash
        const authenticatedUserClone = _.cloneDeep(authenticatedUser);
        const supportDeskClone = _.cloneDeep(supportDesk);
    
        // remove sensitive information
        delete authenticatedUserClone.accessToken;
        delete authenticatedUserClone.refreshToken;
        delete authenticatedUserClone.branchId;
        delete authenticatedUserClone.email;
        delete authenticatedUserClone.status;
    
        const ticket = {
            authenticatedUser: authenticatedUserClone,
            sessionStart: dayjs().unix(),
            volume,
            status: TicketStatuses[action],
            callType //next is to call the next available ticket or recall an active ticket : direct is to call ticket by its number
        };
    
        if (callType === 'direct') {
            ticket.id = activeManagementTicketId;
        }
    
        ticket.manage = {
            supportDesk: supportDeskClone,
            userId: authenticatedUser.id,
        };
    
        const payload = {
            ...PubSubKeys[action],
            msg: {
                ticket
            }
        };
            
        dispatch(callTicket(hostname, payload));
    };

    return <>
        {
            activeManagementTicketId === activeTicketId
                ?   <div className="actionButtonContainer" style={{ opacity: "0.5", pointerEvents: "not-allowed"}}>
                        <div className="actionButton scheme-purple-bg"   >
                            <div>
                                <svg width="24" height="30" viewBox="0 0 24 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.1869 6.82134C11.5579 6.82134 10.9429 6.63481 10.4199 6.28532C9.89686 5.93583 9.48919 5.43909 9.24846 4.85791C9.00773 4.27673 8.94474 3.63722 9.06746 3.02024C9.19019 2.40327 9.49311 1.83654 9.93793 1.39172C10.3827 0.946907 10.9495 0.643984 11.5664 0.52126C12.1834 0.398536 12.8229 0.461522 13.4041 0.702254C13.9853 0.942986 14.482 1.35065 14.8315 1.8737C15.181 2.39675 15.3675 3.01168 15.3675 3.64075C15.3666 4.48402 15.0313 5.29249 14.435 5.88877C13.8387 6.48505 13.0302 6.82044 12.1869 6.82134V6.82134Z" />
                                    <path d="M22.183 6.86683L22.1575 6.87364L22.1336 6.88103C22.0768 6.89693 22.02 6.91397 21.9632 6.93158C20.9063 7.24169 15.7764 8.68772 12.1624 8.68772C8.80407 8.68772 4.13825 7.4382 2.64564 7.01393C2.49709 6.95649 2.34538 6.90757 2.19126 6.8674C1.11213 6.58341 0.373779 7.67959 0.373779 8.68147C0.373779 9.67371 1.26548 10.1463 2.16571 10.4853V10.5012L7.57386 12.1904C8.12649 12.4022 8.27416 12.6186 8.34629 12.806C8.58086 13.4075 8.39343 14.5985 8.32698 15.0143L7.99756 17.5701L6.16929 27.5771C6.16361 27.6043 6.15849 27.6322 6.15395 27.6606L6.14089 27.7327C6.00912 28.65 6.68273 29.54 7.95837 29.54C9.07158 29.54 9.56287 28.7715 9.77586 27.7259C9.98885 26.6803 11.3662 18.7765 12.1613 18.7765C12.9565 18.7765 14.5945 27.7259 14.5945 27.7259C14.8075 28.7715 15.2987 29.54 16.412 29.54C17.691 29.54 18.3646 28.646 18.2294 27.7259C18.2178 27.6485 18.2034 27.5716 18.1863 27.4953L16.333 17.5712L16.0042 15.0154C15.7662 13.5268 15.9576 13.0349 16.0223 12.9196C16.0241 12.9169 16.0256 12.9141 16.0269 12.9111C16.0882 12.7975 16.3676 12.5431 17.0197 12.2983L22.0905 10.5257C22.1216 10.5174 22.1523 10.5075 22.1825 10.4961C23.0912 10.1553 24 9.68393 24 8.68261C24 7.68129 23.2622 6.58342 22.183 6.86683Z"/>
                                </svg>
                            </div>
                            <span>Recall</span>
                        </div>
                    </div>
                :   organizationId === NAMRA_ORGANIZATION_ID && !NAMRA_DIRECT_CALL_ALLOWED_USER_IDS.includes(authenticatedUser.id)
                    ? null
                    : <div className="actionButtonContainer">
                        <div className="actionButton scheme-purple-bg"   onClick={() => ticket.status ? null : manageTicket(-1, 'direct')}>
                            <div>
                                <svg width="24" height="30" viewBox="0 0 24 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.1869 6.82134C11.5579 6.82134 10.9429 6.63481 10.4199 6.28532C9.89686 5.93583 9.48919 5.43909 9.24846 4.85791C9.00773 4.27673 8.94474 3.63722 9.06746 3.02024C9.19019 2.40327 9.49311 1.83654 9.93793 1.39172C10.3827 0.946907 10.9495 0.643984 11.5664 0.52126C12.1834 0.398536 12.8229 0.461522 13.4041 0.702254C13.9853 0.942986 14.482 1.35065 14.8315 1.8737C15.181 2.39675 15.3675 3.01168 15.3675 3.64075C15.3666 4.48402 15.0313 5.29249 14.435 5.88877C13.8387 6.48505 13.0302 6.82044 12.1869 6.82134V6.82134Z" />
                                    <path d="M22.183 6.86683L22.1575 6.87364L22.1336 6.88103C22.0768 6.89693 22.02 6.91397 21.9632 6.93158C20.9063 7.24169 15.7764 8.68772 12.1624 8.68772C8.80407 8.68772 4.13825 7.4382 2.64564 7.01393C2.49709 6.95649 2.34538 6.90757 2.19126 6.8674C1.11213 6.58341 0.373779 7.67959 0.373779 8.68147C0.373779 9.67371 1.26548 10.1463 2.16571 10.4853V10.5012L7.57386 12.1904C8.12649 12.4022 8.27416 12.6186 8.34629 12.806C8.58086 13.4075 8.39343 14.5985 8.32698 15.0143L7.99756 17.5701L6.16929 27.5771C6.16361 27.6043 6.15849 27.6322 6.15395 27.6606L6.14089 27.7327C6.00912 28.65 6.68273 29.54 7.95837 29.54C9.07158 29.54 9.56287 28.7715 9.77586 27.7259C9.98885 26.6803 11.3662 18.7765 12.1613 18.7765C12.9565 18.7765 14.5945 27.7259 14.5945 27.7259C14.8075 28.7715 15.2987 29.54 16.412 29.54C17.691 29.54 18.3646 28.646 18.2294 27.7259C18.2178 27.6485 18.2034 27.5716 18.1863 27.4953L16.333 17.5712L16.0042 15.0154C15.7662 13.5268 15.9576 13.0349 16.0223 12.9196C16.0241 12.9169 16.0256 12.9141 16.0269 12.9111C16.0882 12.7975 16.3676 12.5431 17.0197 12.2983L22.0905 10.5257C22.1216 10.5174 22.1523 10.5075 22.1825 10.4961C23.0912 10.1553 24 9.68393 24 8.68261C24 7.68129 23.2622 6.58342 22.183 6.86683Z"/>
                                </svg>
                            </div>
                            <span>Direct Call</span>
                        </div>
                    </div>
            }
        </>
}

export default AssistTicket;